import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ICardDetail, ICardSearchFields, cardService, ICardFormFields, ICardInsert, ICardUpdate } from "./cardService";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { ISearchPage } from "@/types/AppTypes";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM, defaultMdCmParam } from "@/utils/constants";
import { globalPrompt } from "@/components/message";
import { convertRes2Blob } from "@/utils/exportFile";

interface ICardDrawerType {
    visible: boolean,
    mode: "add" | "edit"
}

export const useCardModel = createModel(function () {
    const { setLoadingInfo } = useGlobalModel();

    //列表数据源
    const [dataSource, setDataSource] = useState<ICardDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ICardSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //人员同步弹框
    const [syncVisible, setSyncVisible] = useState<boolean>(false);
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: ICardSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            sourceApp: defaultMdCmParam.sourceApp,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await cardService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ICardSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    /**
     * 详情
     */
    const initCardDrawer: ICardDrawerType = { visible: false, mode: "add" }
    const [cardDrawer, setCardDrawer] = useState<ICardDrawerType>(initCardDrawer);
    const setICardDrawer = (str?: "add" | "edit") => setCardDrawer(str ? { visible: true, mode: str } : initCardDrawer);

    //根据id查询
    const getSelectedRowData = () => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        return filters && filters.length > 0 ? { ...filters[0] } : {};
    };


    //同步
    const sync = async () => {
        let { retData } = await cardService.sync({ sourceApp: "ebc" });
        globalPrompt("message", { text: "同步成功", type: "success" })
    }

    const downloadTpl = async () => {
        try {
            setLoadingInfo({ loadingVisible: true, txt: '正在下载...' });
            let result = await cardService.downloadTpl();
            convertRes2Blob(result);
            setLoadingInfo({ loadingVisible: false, txt: '' });
        } catch {
            setLoadingInfo({ loadingVisible: false, txt: '' });
        }
    };

    const [reviewVisible, setReviewVisible] = useState<{ visible: boolean, rowDetail: ICardDetail }>({ visible: false, rowDetail: {} });
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        /***method***/
        cardDrawer, setICardDrawer,
        getSelectedRowData,
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        sync,
        reviewVisible, setReviewVisible,
        syncVisible, setSyncVisible,
        downloadTpl, setLoadingInfo
    }
});